var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"ma-0 pa-0"},[_c('TwitterFeedCard'),_c('NrkFeedCard'),_c('NavFeedCard'),_c('Bronnoysund')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }